var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification2FaSuccessIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.375 95.25c-2.25 1-4.5 1-6.75 0-6.25-2.5-12.25-6.562-18-12.187-6.875-6.75-12.375-14.625-16.5-23.625C2.375 48.688 0 36.875 0 24c0-1.875.5-3.563 1.5-5.063 1-1.5 2.375-2.562 4.125-3.187h-.188l36-15c2.376-1 4.688-1 6.938 0l36 15c1.75.625 3.125 1.687 4.125 3.187 1 1.5 1.5 3.188 1.5 5.063 0 11.75-2.125 22.813-6.375 33.188-3.75 9.25-8.938 17.312-15.563 24.187-6 6.375-12.562 11-19.687 13.875z",
    fill: "#0074BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.048 64c1.047 0 1.952-.35 2.714-1.048l24.38-24.38c.7-.762 1.048-1.667 1.048-2.715 0-1.047-.365-1.952-1.095-2.714S64.476 32 63.43 32c-1.048 0-1.953.381-2.715 1.143L39 54.857l-9.429-9.524c-.761-.762-1.666-1.143-2.714-1.143-1.047 0-1.952.381-2.714 1.143S23 47 23 48.048c0 1.047.381 1.952 1.143 2.714l12.19 12.19C37.095 63.651 38 64 39.048 64z",
    fill: "#FFF"
  }))));
}
export default SvgVerification2FaSuccessIco;